import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OrganizerHeader } from "../../components/header";
import { MiniButton, SmallButton } from "../../components/UIkit";
import { push } from "connected-react-router";
import { fechCurrentUser } from "../../reducks/users/operations";
import { getCurrentUser, getUserId } from "../../reducks/users/selectors";

const Account = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const uid = getUserId(selector);
  const currentUser = getCurrentUser(selector);
  const isBoothEditing = true;
  const isOpusEditing = true;

  useEffect(() => {
    dispatch(fechCurrentUser(uid));
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    dispatch(fechCurrentUser(uid));
    // eslint-disable-next-line
  }, [currentUser]);
  return (
    <section>
      <div className="common-container">
        <div className="common-container__header--inner center-box">
          <OrganizerHeader isBoothEditing={isBoothEditing} isOpusEditing={isOpusEditing} />
          <div className="mypage-container center ">
            <h2 className="form-text__headline--l">アカウント情報</h2>
            <div className="spacer-box--s" />
            <div className="basic-text ">現在のメールアドレス</div>
            <div className="spacer-box--ss" />
            <div className="basic-text bold ">{currentUser.email}</div>
            <div className="spacer-box--m" />
            <SmallButton label="メールアドレスを変更する" onClick={() => dispatch(push("/mailEdit"))} />
            <div className="spacer-box--m" />

            <MiniButton label="会員ページへ戻る" onClick={() => dispatch(push(`/organizer/${uid}`))} />

            <div className="spacer-box--l" />
            <div className="form-text__guide hover1" onClick={() => dispatch(push("/passwordEdit"))}>
              パスワードを変更する場合はこちら
            </div>
            <div className="spacer-box--s" />
            <div className="form-text__guide hover1" onClick={() => dispatch(push("/deleteUser"))}>
              アカウントを削除したい場合はこちら
            </div>
            <div className="spacer-box--l" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Account;
